const pad = (n, width, z) => {
  const stringN = `${n}`;
  return stringN.length >= width ?
    stringN :
    new Array(width - stringN.length + 1).join(z || "0") + stringN;
};

export default pad;
